import { View, Text, TouchableOpacity, ImageBackground, SafeAreaView, ScrollView, Image } from 'react-native'
import React from 'react'
import { useState } from 'react';

export default function Hotels() {
    let normalColor = '#d4d4d4';
    let pressedColor = '#e9e9e9';



const data = [{"BookItemId":"189",
              "PriceId":"4",
              "PaxNo":"1",
              "Currency":"PHP",
              "PublishedPrice":"1800.00",
              "ContractedPrice":"1500.00",
              "TerminalFee":"0.00",
              "EnvironmentalFee":"0.00",
              "PriceDesc":"Adult (Foreign)"},
              {"BookItemId":"190",
              "PriceId":"4",
              "PaxNo":"1",
              "Currency":"PHP",
              "PublishedPrice":"1800.00",
              "ContractedPrice":"1500.00",
              "TerminalFee":"0.00",
              "EnvironmentalFee":"0.00",
              "PriceDesc":"Adult (Foreign)"}]

const copydata = [...data]
console.log(copydata)
const rendercart = copydata.map(item => item.PriceDesc)
console.log(data)
console.log(copydata)

  //const renderPriceList = priceList.map(((item, index) => 
  //<View key={index}>
  //    {/* <Text onPress={() => {setLoc1(item.LocationName); setOriginID(item.LocationId)}}>{item.LocationName}</Text> */}
  //     <Text>{item.PriceId} ; {item.Origin} : {item.PriceDesc} : {item.Service} : {item.Route} : {item.PublishedPrice} : {item.PublishedPrice}</Text>
  //     <View><Text></Text></View>
  //</View>
  return (
    <View style={{flexDirection:'row', width: '100%', height: 500 , borderWidth:2, borderColor: '#707070', borderRadius:10, padding:20}}>
      
        <View style={{width:300, height:530}}>
            <View style={{justifyContent:'center', alignItems:'center'}}><Text>COMING SOON!!</Text></View>
        </View>
        <View style={{width:500, height:530}}>

        </View>
    </View>
  )
}